import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "dashboard",
    redirect: "seller/dashboard"
  },
  {
    path: "foods-category",
    name: "foods-category",

    component: () =>
      import(
        /* webpackChunkName: 'foods-category' */ "@/views/foods-category.vue"
      ),
    meta: {
      breadcrumbMenus: ["manageCatalog.catalogSettings"]
    }
  },
  {
    path: "foods-list",
    name: "foods-list",

    component: () =>
      import(/* webpackChunkName: 'foods-list' */ "@/views/foods-list.vue"),
    meta: {
      breadcrumbMenus: ["storeSetting.menuManagement", "storeSetting.menuList"]
    }
  },
  {
    path: "seller/nolist",
    name: "seller-no-list",
    component: () =>
      import(/* webpackChunkName: 'foods-list' */ "@/views/seller-no-list.vue"),
    meta: {
      breadcrumbMenus: ["无菜单餐厅列表"]
    }
  },
  {
    path: "foods/:id/edit",
    name: "foods-editor",

    component: () =>
      import(/* webpackChunkName: 'foods-editor' */ "@/views/foods-editor.vue"),
    meta: {
      breadcrumbMenus: [
        "storeSetting.menuManagement",
        "storeSetting.menuManaEdit"
      ]
    }
  },
  {
    path: "foods/add",
    name: "foods-add",

    component: () =>
      import(/* webpackChunkName: 'foods-editor' */ "@/views/foods-editor.vue"),
    meta: {
      breadcrumbMenus: ["storeSetting.menuManagement", "storeSetting.addFood"]
    }
  },
  {
    path: "order/list",
    name: "order-list",

    component: () =>
      import(/* webpackChunkName: 'foods-editor' */ "@/views/order-list.vue"),
    meta: {
      breadcrumbMenus: ["storeSetting.orderManagement"]
    }
  },
  {
    path: "statistics",
    name: "statistics",

    component: () =>
      import(/* webpackChunkName: 'foods-editor' */ "@/views/statistics.vue"),
    meta: {
      breadcrumbMenus: ["数据统计"]
    }
  },
  {
    path: "statistics",
    name: "statistics",

    component: () =>
      import(/* webpackChunkName: 'foods-editor' */ "@/views/statistics.vue"),
    meta: {
      breadcrumbMenus: ["数据统计"]
    }
  },
  {
    path: "statisticsmore",
    name: "statisticsmore",

    component: () =>
      import(
        /* webpackChunkName: 'foods-editor' */ "@/views/statisticsmore.vue"
      ),
    meta: {
      breadcrumbMenus: ["数据统计趋势图"]
    }
  },
  {
    path: "getgetSuggest",
    name: "getgetSuggest",

    component: () =>
      import(
        /* webpackChunkName: 'foods-editor' */ "@/views/getgetSuggest.vue"
      ),
    meta: {
      breadcrumbMenus: ["平台反馈数据"]
    }
  },
  {
    path: "imagegallery",
    name: "imagegallery",
    component: () => import("@/views/imagegallery.vue"),
    meta: {
      breadcrumbMenus: ["图片库"]
    }
  },
  {
    path: "emaile-admi",
    name: "emaile-admi",
    component: () => import("@/views/emaile-admin.vue"),
    meta: {
      breadcrumbMenus: ["邮件管理"]
    }
  },
  {
    path: "blacklist-admin",
    name: "blacklist-admin",
    component: () => import("@/views/blacklist-admin.vue"),
    meta: {
      breadcrumbMenus: ["黑名单管理"]
    }
  },
  {
    path: "reviews",
    name: "reviews",

    component: () =>
      import(/* webpackChunkName: 'foods-editor' */ "@/views/reviews.vue"),
    meta: {
      breadcrumbMenus: ["评论"]
    }
  },
  {
    path: "order/om",
    name: "order-om",

    component: () =>
      import(/* webpackChunkName: 'foods-editor' */ "@/views/order-om.vue"),
    meta: {
      breadcrumbMenus: ["storeSetting.orderManagement"]
    }
  },
  {
    path: "RestaurantType",
    name: "RestaurantType",

    component: () =>
      import(/* webpackChunkName: 'rating' */ "@/views/RestaurantType.vue"),
    meta: {
      breadcrumbMenus: ["餐厅类型管理"]
    }
  },
  {
    path: "rating",
    name: "rating",

    component: () =>
      import(/* webpackChunkName: 'rating' */ "@/views/rating.vue"),
    meta: {
      breadcrumbMenus: ["评价管理"]
    }
  },
  {
    path: "seller/dashboard",
    name: "seller-dashboard",

    component: () =>
      import(
        /* webpackChunkName: 'seller-dashboard' */ "@/views/seller-dashboard.vue"
      ),
    meta: {
      breadcrumbMenus: [
        "storeSetting.storeManagement",
        "storeSetting.storeStatistics"
      ]
    }
  },
  {
    path: "seller/configuration",
    name: "seller-configuration",
    component: () => import("@/views/seller-configuration.vue"),
    meta: {
      breadcrumbMenus: [
        "storeSetting.storeManagement",
        "storeSetting.storeSetting"
      ]
    }
  },
  {
    path: "seller/add",
    name: "seller-add",
    component: () => import("@/views/seller-add.vue"),
    meta: {
      breadcrumbMenus: [
        "storeSetting.storeManagement",
        "storeSetting.storeSetting",
        "storeSetting.addStore"
      ]
    }
  },
  {
    path: "seller/addMore",
    name: "seller-add-more",
    component: () => import("@/views/seller-add-more.vue"),
    meta: {
      breadcrumbMenus: [
        "storeSetting.storeManagement",
        "storeSetting.storeSetting",
        "storeSetting.addStore"
      ]
    }
  },
  // {
  //   path: 'seller/option',
  //   name: 'seller-option',
  //   component: () =>
  //     import( '@/views/seller-option.vue'),
  //     meta: {
  //       breadcrumbMenus: ['storeSetting.storeManagement', 'storeSetting.storeSetting', 'storeSetting.addStore'],
  //     },
  // },
  {
    path: "seller/list",
    name: "seller-list",
    component: () => import("@/views/seller-list.vue"),
    meta: {
      breadcrumbMenus: [
        "storeSetting.storeManagement",
        "storeSetting.storeSetting",
        "storeSetting.addStore",
        "storeSetting.restaurantList"
      ]
    }
  },

  {
    path: "seller/bill",
    name: "seller-bill",
    component: () => import("@/views/seller-bill.vue"),
    meta: {
      breadcrumbMenus: ["storeSetting.storeManagement"]
    }
  },
  {
    path: "seller/billS",
    name: "seller-billS",
    component: () => import("@/views/seller-billS.vue"),
    meta: {
      breadcrumbMenus: ["storeSetting.storeManagement"]
    }
  },

  {
    path: "setting",
    name: "setting",

    component: () =>
      import(/* webpackChunkName: 'setting' */ "@/views/setting.vue"),
    meta: {
      breadcrumbMenus: ["settings.setting"]
    }
  },
  {
    path: "administrator",
    name: "administrator",

    component: () =>
      import(
        /* webpackChunkName: 'administrator' */ "@/views/administrator.vue"
      ),
    meta: {
      breadcrumbMenus: ["storeSetting.administrators"]
    }
  },
  {
    path: "user/list",
    name: "user-list",
    component: () =>
      import(/* webpackChunkName: 'administrator' */ "@/views/user-list.vue"),
    meta: {
      breadcrumbMenus: ["用户列表"]
    }
  }
];
console.log(process.env.BASE_URL, "process.env.BASE_URL");
const router = new VueRouter({
  // mode: 'history',
  // base: '/admin/',
  routes: [
    {
      name: "authLayout",
      path: "/auth",
      component: () =>
        import(/* webpackChunkName:'auth' */ "@/layout/auth.vue"),
      children: [
        {
          name: "login",
          path: "login",
          component: () => import("@/views/login")
        }
      ]
    },
    {
      name: "basicLayout",
      path: "/",
      component: () =>
        import(/* webpackChunkName:'basiclayout' */ "@/layout/basic.vue"),
      children: routes
    },
    {
      path: "*",
      redirect: "/seller/dashboard"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === "/auth/login") {
    return next();
  }
  const accessToken = sessionStorage.getItem("token");

  return accessToken ? next() : next("/auth/login");
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js